import { ReportContractsToInstallmentsPDF } from "./Components/PDF/ReportContractsToInstallmentsPDF";
import { useReportContractsToInstallments } from "./Hooks/useReportContractsToInstallments";
import { DrawerFilterContractsToInstallments } from "./Components/DrawerFilter/DrawerFilterContractsToInstallments";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportContractsToInstallments = () => {
  const { loadingGravar } = useConfigPageContext();

  const {
    filters,
    loading,
    report,
    submittedFilters,
    setFilters,
    handleClearFilters,
    handleSubmit,
  } = useReportContractsToInstallments();
  const hasData = !!report?.data?.length;
  return (
    <>
      <CardHeaderCore
        buttonAdd={[
          <DrawerFilterContractsToInstallments
            key="filter"
            filters={filters}
            loading={loading}
            onChange={setFilters}
            onClear={handleClearFilters}
            onSubmit={handleSubmit}
          />,
        ]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de contratos com parcelas com filtros personalizados"
        title="Relatório de contratos com parcelas"
      />
      <ReportContractsToInstallmentsPDF
        loading={loading}
        report={report}
        filters={submittedFilters}
      />

      {!hasData && !loadingGravar && <NoEmptyPdfCore />}
    </>
  );
};
